ACC.addressbook = {
  taxIncludeWrapper: 'ph-tax_include_wrapper',

  showall: function() {
    var taxIncludeWrapperClass = ACC.addressbook.taxIncludeWrapper;

    $(document).on('click', '.ph-myprofileaddress__billingshowall', function(e) {
      ACC.addressbook.billingshowallclick(e);
      $('.' + taxIncludeWrapperClass).addClass('hidden');
    });
    $(document).on('click', '.ph-myprofileaddress__shippingshowall', function(e) {
      ACC.addressbook.shippingshowallclick(e);
      $('.' + taxIncludeWrapperClass).addClass('hidden');
    });
    $(document).on('click', '.ph-myprofileaddress__payeeshowall', function(e) {
      ACC.addressbook.payeeshowallclick(e);
      $('.' + taxIncludeWrapperClass).addClass('hidden');
    });
    $(document).on('click', '.ph-myprofileaddress__billingeditadd', function() {
      ACC.addressbook.billingeditaddclick($(this));
      $('.' + taxIncludeWrapperClass).addClass('hidden');
    });
    $(document).on('click', '.ph-myprofileaddress__shippingeditadd', function() {
      ACC.addressbook.shippingeditaddclick($(this));
      $('.' + taxIncludeWrapperClass).addClass('hidden');
    });
    $(document).on('click', '.ph-myprofileaddress__payeeeditadd', function() {
      ACC.addressbook.payeeeditaddclick($(this));
      $('.' + taxIncludeWrapperClass).addClass('hidden');
    });
    $(document).on('click', '.ph-myprofileaddress__billingaddnew', function() {
      ACC.addressbook.billingaddnewclick($(this));
      $('.' + taxIncludeWrapperClass).addClass('hidden');
    });
    $(document).on('click', '.ph-myprofileaddress__shippingaddnew', function() {
      ACC.addressbook.shippingaddnewclick($(this));
      $('.' + taxIncludeWrapperClass).removeClass('hidden');
    });
    $(document).on('click', '.ph-myprofileaddress__payeeaddnew', function() {
      ACC.addressbook.payeeaddnewclick($(this));
      $('.' + taxIncludeWrapperClass).addClass('hidden');
    });
    $(document).on('click', '.ph-myprofileaddress__billingaddnewoutside', function() {
      ACC.addressbook.billingaddnewoutsideclick($(this));
      $('.' + taxIncludeWrapperClass).addClass('hidden');
    });
    $(document).on('click', '.ph-myprofileaddress__shippingaddnewoutside', function() {
      ACC.addressbook.shippingaddnewoutsideclick($(this));
      $('.' + taxIncludeWrapperClass).removeClass('hidden');
    });
    $(document).on('click', '.ph-myprofileaddress__payeeaddnewoutside', function() {
      ACC.addressbook.payeeaddnewoutsideclick($(this));
      $('.' + taxIncludeWrapperClass).addClass('hidden');
    });
    $(document).on('click', '.ph-myprofileaddress__billingsavereq', function() {
      var taxFile = new FormData(document.getElementById('addressTax')),
          $clickedButton = $(this),
          houseNumber = '';

      taxFile.append('companyname', $('#cboxContent .ph-myprofilepage__companyname').val());
      taxFile.append('companyname2', $('#cboxContent .ph-myprofilepage__companyname2').val());
      taxFile.append('pobox', $('#cboxContent .ph-myprofilepage__pobox').val());
      taxFile.append('address', $('#cboxContent .ph-myprofilepage__address').val());
      taxFile.append('postalcode', $('#cboxContent .ph-myprofilepage__postalcode').val());
      taxFile.append('state', $('#cboxContent .ph-myprofilepage__state').val());
      taxFile.append('city', $('#cboxContent .ph-myprofilepage__city').val());
      taxFile.append('addressType', $('#cboxContent .ph-myprofilepage__addressType').val());
      taxFile.append('editAddressFlag', $('#cboxContent .ph-editaddesscheckboolean').val());
      taxFile.append('newAddressFlag', $('#cboxContent .ph-newaddesscheckboolean').val());
      taxFile.append('customerNo', $('#cboxContent #customerNo').val());
      taxFile.append('salesOrg', $('#cboxContent #salesOrg').val());
      taxFile.append('accountNo', $('#cboxContent #accountNo').val());
      taxFile.append('addressLine2', $('#cboxContent .ph-myprofilepage__addressLine2').val());

      if ($('#cboxContent .ph-myprofilepage__housenumber').val()) {
        houseNumber = $('#cboxContent .ph-myprofilepage__housenumber').val();
      }

      taxFile.append('houseNumber', houseNumber);
      ACC.addressbook.validationaddress(taxFile, $clickedButton);
    });
  },

  hideSection: function() {
    $('.ph-list').parents('.ph_hidesection').css('display', 'block');
    $('.ph-resultnotfound').hide();
  },

  popupstructure: function(name) {
    $.colorbox({
      html: name.html(),
      maxWidth: '522px',
      width: '100%',
      height: '100%',
      maxHeight: '600px',
      scrolling: true,
      close: '<button type=\'button\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>',
      onClosed: function() {
        ACC.addressbook.hideSection();
        ACC.common.refreshScreenReaderBuffer();
        $('html').removeClass('ph-modal-open');
        $('#cboxWrapper #myInput').each(function() {
          $(this).focus();
        });
      },
      onComplete: function() {
        $('#cboxWrapper #myInput').each(function() {
          var inputVal = $(this).val();

          $(this).focus();
          $(this).keypress(function() {
            if (this.value === inputVal) {
              this.value = '';
            }
          });
        });

        ACC.addressBookSearchFunctionality.addressSearch();

        if ($(window).width() < 768) {
          $('html').addClass('ph-modal-open');
        }

        var outerPopupHeight = $('#cboxLoadedContent').outerHeight() - 15,
            shopFooterHeight = $('.ph-addfootersection').outerHeight(),
            finalShopDivHeight = outerPopupHeight - shopFooterHeight;

        $('.ph-addpopupmain').css({
          minHeight: 200,
          height: finalShopDivHeight
        });
      }
    });
  },

  editaddpopup: function(name) {
    $.colorbox({
      html: name.html(),
      maxWidth: '500px',
      width: '100%',
      height: '90%;',
      close: '<button type=\'button\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>',
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
        $('html').removeClass('ph-modal-open');
        $(ACC.addressbook.taxIncludeWrapper).addClass('hidden');
      },
      onComplete: function() {
        $('select').selectBox();
        ACC.common.refreshSelectBoxArrow();

        if (window.navigator.userAgent.indexOf('MSIE ') > 0 || window.navigator.userAgent.indexOf('Trident/') > 0) {
          $('.ph-forminput').parent().find('.ph-formlabel').addClass('ph-ielabel');
        } else {
          $('.ph-forminput').parent().find('.ph-formlabel').removeClass('ph-ielabel');
        }
      }
    });
  },

  billingshowallclick: function(event) {
    $('select').selectBox('destroy');
    ACC.addressbook.popupstructure($(event.target).parent('.ph-billingButtons').siblings('.ph-myprofileaddress__billingpopup'));
  },

  shippingshowallclick: function(event) {
    $('select').selectBox('destroy');
    ACC.addressbook.popupstructure($(event.target).parent('.ph-shippingButtons').siblings('.ph-myprofileaddress__shippingpopup'));
  },

  payeeshowallclick: function(event) {
    $('select').selectBox('destroy');
    ACC.addressbook.popupstructure($(event.target).parent('.ph-payeeButtons').siblings('.ph-myprofileaddress__payeepopup'));
  },

  billingeditaddclick: function(obj) {
    $('select').selectBox('destroy');
    ACC.addressbook.editaddpopup(obj.siblings('.ph-myprofileaddress__billingeditaddpopup'));
  },

  shippingeditaddclick: function(obj) {
    $('select').selectBox('destroy');
    ACC.addressbook.editaddpopup(obj.siblings('.ph-myprofileaddress__shippingeditaddpopup'));
  },

  payeeeditaddclick: function(obj) {
    $('select').selectBox('destroy');
    ACC.addressbook.editaddpopup(obj.siblings('.ph-myprofileaddress__payeeeditaddpopup'));
  },

  billingaddnewclick: function(obj) {
    $('select').selectBox('destroy');
    ACC.addressbook.editaddpopup(obj.parents('.ph-addfootersection').siblings('.ph-myprofileaddress__billingaddnewpopup'));
  },

  shippingaddnewclick: function(obj) {
    $('select').selectBox('destroy');
    ACC.addressbook.editaddpopup(obj.parents('.ph-addfootersection').siblings('.ph-myprofileaddress__shippingaddnewpopup'));
  },

  payeeaddnewclick: function(obj) {
    $('select').selectBox('destroy');
    ACC.addressbook.editaddpopup(obj.parents('.ph-addfootersection').siblings('.ph-myprofileaddress__payeeaddnewpopup'));
  },

  billingaddnewoutsideclick: function(obj) {
    $('select').selectBox('destroy');
    ACC.addressbook.editaddpopup(obj.siblings('.ph-myprofileaddress__billingaddnewpopup'));
  },

  shippingaddnewoutsideclick: function(obj) {
    $('select').selectBox('destroy');
    ACC.addressbook.editaddpopup(obj.siblings('.ph-myprofileaddress__shippingaddnewpopup'));
  },

  payeeaddnewoutsideclick: function(obj) {
    $('select').selectBox('destroy');
    ACC.addressbook.editaddpopup(obj.siblings('.ph-myprofileaddress__payeeaddnewpopup'));
  },

  addanotherAddressPopup: function(obj) {
    $.colorbox({
      html: obj,
      maxWidth: '500px',
      width: '100%',
      height: '90%;',
      close: '<button type=\'button\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>',
      onComplete: function() {
        $('select').selectBox();
        ACC.common.refreshSelectBoxArrow();
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
        $('html').removeClass('ph-modal-open');
      }
    });
  },

  addressSelectBoxPopup: function(addNewPopupClass) {
    $('select').selectBox('destroy');
    ACC.addressbook.addanotherAddressPopup($(addNewPopupClass).html());
  },

  addnewAddressButtons: function() {
    $(document).on('click', '.ph-myprofileaddress__addanotheraddress', function() {
      ACC.addressbook.addressSelectBoxPopup('.ph-myprofileaddress__billingaddnewpopup');
      $(ACC.addressbook.taxIncludeWrapper).addClass('hidden');
    });
    $(document).on('click', '.ph-myprofileaddress__shippingaddanotheraddress', function() {
      ACC.addressbook.addressSelectBoxPopup('.ph-myprofileaddress__shippingaddnewpopup');
      $(ACC.addressbook.taxIncludeWrapper).removeClass('hidden');
    });
    $(document).on('click', '.ph-myprofileaddress__payeeaddanotheraddress', function() {
      ACC.addressbook.addressSelectBoxPopup('.ph-myprofileaddress__payeeaddnewpopup');
      $(ACC.addressbook.taxIncludeWrapper).addClass('hidden');
    });
  },

  validationaddress: function(taxFile, $clickedButton) {
    $('#cboxContent input.ph-myprofilepage__inputs,#cboxContent select.ph-myprofilepage__inputs').each(function() {
      if ($(this).val() === '' || $(this).val() === null) {
        $(this).siblings('.ph-adderror').show();
        $('#cboxContent .ph-myprofilepage__postalcode').siblings('.ph-invaliderror').hide();
        $(this).parent('.form_field-input').addClass('ph-form_field_erroradd');
        $(this).addClass('ph-validationsuccess');
      } else {
        $(this).siblings('.ph-adderror').hide();
        $('#cboxContent .ph-myprofilepage__postalcode').siblings('.ph-invaliderror').hide();
        $(this).parent('.form_field-input').removeClass('ph-form_field_erroradd');
        $(this).removeClass('ph-validationsuccess');
      }
    });


    var postalcodeValue = $('#cboxContent .ph-myprofilepage__postalcode').val();

    if (postalcodeValue !== '') {
      if (ACC.validation.postalCode(postalcodeValue)) {
        $('#cboxContent .ph-myprofilepage__postalcode').siblings('.ph-invaliderror').show();
        $('#cboxContent .ph-myprofilepage__postalcode').parent('.form_field-input').addClass('ph-form_field_erroradd');
        $('#cboxContent .ph-myprofilepage__postalcode').addClass('ph-validationsuccess');
      } else {
        $('#cboxContent .ph-myprofilepage__postalcode').siblings('.ph-invaliderror').hide();
        $('#cboxContent .ph-myprofilepage__postalcode').parent('.form_field-input').removeClass('ph-form_field_erroradd');
        $('#cboxContent .ph-myprofilepage__postalcode').removeClass('ph-validationsuccess');
      }
    }

    if ($('#cboxContent .ph-validationsuccess').length === 0) {
      $(ACC.configit.defaultloader).css('z-index', '99999').show();
      $.ajax({
        url: ACC.config.contextPath + '/my-account/profile/updateAddress',
        data: taxFile,
        type: 'POST',
        contentType: false,
        processData: false,
        enctype: 'multipart/form-data',

        success: function() {
          $(ACC.configit.defaultloader).hide();
          $.colorbox({
            html: $clickedButton.parents('#cboxLoadedContent').find('.ph-myprofileaddress__addsuccessfulpopup').html(),
            maxWidth: '500px',
            width: '100%',
            height: '42%;',
            close: '<button type=\'button\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>',
            onClosed: function() {
              ACC.common.refreshScreenReaderBuffer();
              $('html').removeClass('ph-modal-open');
            }
          });
        }
      });
    }
  }
};

$(document).ready(function() {
  ACC.addressbook.showall();

  if ($('.ph-page-profile').length > 0) {
    ACC.addressbook.addnewAddressButtons();
  }

  $(document).on('change', '.taxIncludeFlag', function() {
    var $this = $(this),
        fileWrapper = $this.closest('.ph-tax_include_wrapper').find('.fileToUploadHolder');

    if ($this.is(':checked')) {
      $this.val('true');
      fileWrapper.removeClass('hidden');
    } else {
      $this.val('false');
      fileWrapper.addClass('hidden');
    }
  });
  $(document).on('change', '#fileToUpload', function() {
    var $this = $(this);

    if ((/(\.pdf|\.png|\.gif|\.jpg|\.jpeg)$/i).test($this.val())) {
      $('#formateErrorMessage').hide();
    } else {
      $('#formateErrorMessage').show();
      $this.val('');
    }
  });
});
